import React, { Component } from 'react'

export default class ContactUs extends Component {
  render() {
    return (
      <div className="contact-container">
          <section className="-z-6 text-gray-600 body-font ">
               <div className="container px-5 py-24 mx-auto">
               <div className="flex flex-col text-center w-full mb-12">
                    <h1 className="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">Contact Us</h1>
                    <p className="lg:w-2/3 mx-auto leading-relaxed text-base">Whatever cardigan tote bag tumblr hexagon brooklyn asymmetrical gentrify.</p>
               </div>
               <div className="lg:w-1/2 md:w-2/3 mx-auto">
                    <div className="flex flex-wrap -m-2">
                    <div className="p-2 w-1/2">
                         <div className="">
                         <label for="name" className="leading-7 text-sm text-gray-600">Name</label>
                         <input type="text" id="name" name="name" className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-brightRedLight focus:bg-white focus:ring-2 focus:ring-brightRedLight text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"/>
                         </div>
                    </div>
                    <div className="p-2 w-1/2">
                         <div className="">
                         <label for="email" className="leading-7 text-sm text-gray-600">Email</label>
                         <input type="email" id="email" name="email" className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-brightRedLight focus:bg-white focus:ring-2 focus:ring-brightRedLight text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"/>
                         </div>
                    </div>
                    <div className="p-2 w-full">
                         <div className="">
                         <label for="message" className="leading-7 text-sm text-gray-600">Message</label>
                         <textarea id="message" name="message" className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-brightRedLight focus:bg-white focus:ring-2 focus:ring-brightRedLight h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"></textarea>
                         </div>
                    </div>
                    <div className="p-2 w-full">
                         <button className="flex mx-auto  text-white bg-brightRed border-0 py-2 px-8 focus:outline-none active:bg-brightRedLight rounded hover:shadow-lg transition duration-3 0 ease-in-out text-lg">Submit</button>
                    </div>
                    </div>
               </div>
               </div>
               </section>
      </div>
    )
  }
}
